export default {
	'invoice-category': 'categoría de factura',
	'add-invoice-category': 'agregar categoría de factura',
	'use-category-for': 'Usar categoría para',
	'set-a-default-for': 'Establecer como predeterminado para',

	'default-sales-category': 'Ventas predeterminada categoría',
	'default-purchases-category': 'Compras predeterminadas categoría',
	'default-sales-refund-category': 'Ventas predeterminado categoría de reembolso',
	'default-purchases-refund-category': 'Compras predeterminadas categoría de reembolso',

	'default-invoices-categories': 'Categorías predeterminadas'
}